export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 91,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_lable_resFabricPurchaseNo') || '采购单号',
    field: 'resFabricPurchaseNo',
    minWidth: 154,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_lable_purchaseDate') || '采购日期',
    field: 'purchaseDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_lable_expectedDeliveryDate') || '期望到货日期',
    field: 'expectedDeliveryDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'resFabricPurchaseStatus',
    minWidth: 105,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmCode') || '供应商',
    field: 'scmName',
    minWidth: 181,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_lable_resFabricScmName') || '店铺厂家',
    field: 'resFabricScmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_total_amount') || '合计金额',
    field: 'totalAmount',
    minWidth: 166,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    slots: { default: 'createByName' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    slots: { default: 'modifyByName' }
  }
]
